// extracted by mini-css-extract-plugin
export default {"v2Grid":"S0g79XgisW7EmjICTHcQ","v2ExtrasHeading":"D90C2CVsaF402DhS_wbX","v2ExtrasRow":"jAgRVzU9MEf36knAfLkl"};